var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWithdrawLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_367_6273",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_367_6273)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60001 20.3999C3.60001 19.7371 4.13726 19.1999 4.80001 19.1999H19.2C19.8628 19.1999 20.4 19.7371 20.4 20.3999C20.4 21.0627 19.8628 21.5999 19.2 21.5999H4.80001C4.13726 21.5999 3.60001 21.0627 3.60001 20.3999ZM7.55148 8.04845C7.08285 7.57981 7.08285 6.81999 7.55148 6.35136L11.1515 2.75139C11.3765 2.52635 11.6817 2.3999 12 2.3999C12.3183 2.3999 12.6235 2.52635 12.8485 2.75139L16.4485 6.35136C16.9171 6.81999 16.9171 7.57981 16.4485 8.04845C15.9799 8.51707 15.2201 8.51707 14.7515 8.04845L13.2 6.49696V15.5999C13.2 16.2627 12.6627 16.7999 12 16.7999C11.3373 16.7999 10.8 16.2627 10.8 15.5999V6.49696L9.24853 8.04845C8.7799 8.51707 8.02011 8.51707 7.55148 8.04845Z",
    fill: "url(#paint0_linear_367_6273)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_367_6273",
    x1: 3.60001,
    y1: 12.139,
    x2: 20.4,
    y2: 12.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdrawLight);
export default __webpack_public_path__ + "static/media/icon_withdraw_light.f96e9ddb0a2de4352762301459349725.svg";
export { ForwardRef as ReactComponent };